import { render, staticRenderFns } from "./CourseLssuedDialog.vue?vue&type=template&id=0ea0bffe&scoped=true&"
import script from "./CourseLssuedDialog.vue?vue&type=script&lang=js&"
export * from "./CourseLssuedDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea0bffe",
  null
  
)

export default component.exports